import React from 'react';
import { useTranslation } from 'react-i18next';
import { SingleSelect } from '@unmind/design-system';
import styled from 'styled-components';
import { rem } from 'polished';
import { Subtitle } from './styles';

export enum CalendarType {
  Office365 = 'Office 365',
  Outlook = 'Outlook',
  iCalendar = 'iCalendar',
  Google = 'Google',
  Yahoo = 'Yahoo',
}

export const SelectContainer = styled.div`
  width: 100%;
  margin: ${rem(12)} 0;
`;

interface CalendarTypeDropdownProps {
  value?: string | CalendarType;
  onChange(field: string, value: CalendarType): void;
}

export const CalendarDropdown = ({
  value,
  onChange,
}: CalendarTypeDropdownProps) => {
  const { t: translate } = useTranslation('shared');

  const supportedCalendars = [
    CalendarType.iCalendar,
    CalendarType.Office365,
    CalendarType.Outlook,
    CalendarType.Google,
    CalendarType.Yahoo,
  ];

  return (
    <>
      <Subtitle>
        {translate('add_to_calendar.calendar_dropdown.title')}
      </Subtitle>
      <SelectContainer>
        <SingleSelect
          id="calendar-type-select"
          placeholder={translate(
            'add_to_calendar.calendar_dropdown.placeholder',
          )}
          options={supportedCalendars.map(option => ({
            // @ts-ignore
            label: option,
            value: option,
          }))}
          selectedValue={value}
          onChange={selection =>
            onChange('calendarType', selection as CalendarType)
          }
          aria-label={translate(
            'add_to_calendar.calendar_dropdown.accessibility_label',
            { value },
          )}
        />
      </SelectContainer>
    </>
  );
};
